<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span class="h4 my-0">SOLICITUD TRANSFERENCIA RECURSOS</span>

        <div class="d-flex flex-wrap align-center">
          <div>
            <v-pagination
              class="custom-pagination"
              v-model="pagina"
              :length="metadatos?.total_paginas"
              :total-visible="10"
              @input="listar"></v-pagination>
          </div>

          <div style="max-width: 150px">
            <v-select
              :items="[10, 25, 50, 75, 100]"
              label="Items por página"
              v-model="limite"
              outlined
              dense
              hide-details
              :disabled="items.length == 0"
              @change="cambiarPagina" />
          </div>
        </div>
      </div>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="4" lg="3">
        <v-btn
          v-if="!permisosPresupuestos3"
          small
          color="primary"
          class="mx-1"
          @click="$refs.presupuestoSolicitudTransferenciaRecursos.abrirModal('registrar', [])">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          v-if="!permisosPresupuestos3"
          small
          class="mx-1"
          :disabled="deshabilitarBotonEditar"
          @click="$refs.presupuestoSolicitudTransferenciaRecursos.abrirModal('actualizar', item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>

        <v-btn small class="mx-1" :disabled="item == null" @click="$refs.modalVisualizarSolicitud.abrir(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>

        <v-btn small class="mx-1" :disabled="item == null" :loading="cargandoVerPdf" @click="verPdf(item.id)">
          <v-icon>mdi-printer</v-icon>
        </v-btn>

        <v-btn
          v-if="!permisosPresupuestos3"
          small
          class="mx-1"
          :disabled="deshabilitarBotonRegistrarPagos"
          @click="$refs.modalFormSolicitudTransferencia.abrirModal('verificar', item)">
          <v-icon>mdi-cash</v-icon>
        </v-btn>

        <v-btn small class="mx-1" @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="4" lg="3">
        <v-menu
          ref="menuFechaDeSolicitud"
          v-model="menuFechaDeSolicitud"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="rangoFechas"
              label="Fecha de Solicitud"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              clearable
              hide-details
              v-bind="attrs"
              v-on="on"></v-text-field>
          </template>

          <v-date-picker
            v-model="rangoFechas"
            no-title
            scrollable
            range
            locale="es-ES"
            :max="fechaDeHoy()"
            @input="rangoFechas.length == 2 && listarRestableciendoPagina()">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFechaDeSolicitud = false"> Cancelar </v-btn>
            <v-btn text color="primary" @click="$refs.menuFechaDeSolicitud.save(rangoFechas)"> Aceptar </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="4" lg="2">
        <v-select
          :items="itemsFiltroEstadoSolicitud"
          label="Estado Solicitud"
          item-text="text"
          item-value="value"
          v-model="estado"
          outlined
          dense
          hide-details
          @change="cambiarFiltroEstadoSolicitud" />
      </v-col>

      <v-col cols="12" md="8" lg="4">
        <v-combobox
          v-model="estadosSeleccionadosDetalleSolicitud"
          :items="itemsFiltroEstadoDetalleSolicitud"
          label="Estado Detalle Solicitud"
          dense
          clearable
          multiple
          hide-details
          outlined>
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              class="my-2"
              x-small
              v-bind="attrs"
              :color="obtenerColorEstadoDetalleSolicitud(item)"
              text-color="white"
              :input-value="selected"
              close
              @click="select"
              @click:close="removerEstadoSeleccionado(item)">
              <strong>{{ item }}</strong>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="12" md="4" lg="2">
        <v-switch
          v-if="permisosPresupuestos2"
          style="margin-top: -4px"
          v-model="checkbox"
          hide-details
          label="Ver todas las sedes"></v-switch>
      </v-col>

      <v-col cols="12" md="6" lg="5">
        <v-btn small class="mx-1" :disabled="items.length == 0" :loading="cargandoVerPdfTodos" @click="verPdfTodos">
          <v-icon>mdi-printer</v-icon>
          Todos
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          :disabled="items.length == 0"
          small
          class="mx-1"
          :loading="cargandoVerPdfTodosConsolidadoSubtotales"
          @click="verPdfTodosConsolidadoSubtotales">
          <v-icon>mdi-printer</v-icon>
          Consolidado
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          :disabled="items.length == 0"
          small
          class="mx-1"
          :loading="cargandoVerPdfTodosConsolidadoPorCuentaOrigen"
          @click="verPdfTodosConsolidadoPorCuentaOrigen">
          <v-icon>mdi-printer</v-icon>
          C. C. Origen
        </v-btn>
      </v-col>

      <v-col cols="12" md="2" lg="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQueryBack"></v-text-field>
      </v-col>

      <v-col cols="12" md="4" lg="3">
        <v-menu
          ref="menuFechaDeDesembolso"
          v-model="menuFechaDeDesembolso"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          :disabled="deshabilitadoRangoFechasDesembolso"
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="rangoFechasDesembolso"
              label="Fecha de Desembolso"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              clearable
              hide-details
              :disabled="deshabilitadoRangoFechasDesembolso"
              v-bind="attrs"
              v-on="on"></v-text-field>
          </template>

          <v-date-picker
            v-model="rangoFechasDesembolso"
            no-title
            scrollable
            range
            locale="es-ES"
            :max="fechaDeHoy()"
            @input="rangoFechasDesembolso.length == 2 && listarRestableciendoPagina()">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFechaDeDesembolso = false"> Cancelar </v-btn>
            <v-btn text color="primary" @click="$refs.menuFechaDeDesembolso.save(rangoFechasDesembolso)">
              Aceptar
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12">
        <ListadoSolicitudTransferenciaRecursos
          ref="listadoRef"
          :items="items"
          :cargando="cargando"
          :sumasTotales="metadatos?.sumas_totales"
          @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormSolicitudTransferenciaRecursos
      ref="presupuestoSolicitudTransferenciaRecursos"
      @actualizarListado="listarRestableciendoPagina">
    </ModalFormSolicitudTransferenciaRecursos>

    <ModalVisualizarSolicitud ref="modalVisualizarSolicitud" @actualizar="listar" :mostrarAccionesArchivoAdjunto="true">
    </ModalVisualizarSolicitud>

    <ModalFormSolicitudTransferencia
      ref="modalFormSolicitudTransferencia"
      @actualizarListado="listar"></ModalFormSolicitudTransferencia>

    <notifications group="notifications" position="top right" />

    <VerPdf ref="verPdf" :fnDescarga="fnDescarga" @cerradoModal="fnDescarga = null" />
  </div>
</template>
 
<script>
import ListadoSolicitudTransferenciaRecursos from '../views/ListadoSolicitudTransferenciaRecursos.vue';
import ModalFormSolicitudTransferenciaRecursos from '../components/ModalFormSolicitudTransferenciaRecursos.vue';
import solicitudRecursosMixin from '../mixins/solicitud-recursos-mixin';
import moment from 'moment';
import { ESTADOS_DETALLE_SOLICITUD, ESTADOS_SOLICITUD, TIPOS_SOLICITUD } from '../utils';
import ModalVisualizarSolicitud from '../components/ModalVisualizarSolicitud.vue';
import ModalFormSolicitudTransferencia from '../components/ModalFormSolicitudTransferencia.vue';

export default {
  name: 'SolicitudTransferenciaRecursos',
  mixins: [solicitudRecursosMixin],
  components: {
    ListadoSolicitudTransferenciaRecursos,
    ModalFormSolicitudTransferenciaRecursos,
    ModalVisualizarSolicitud,
    ModalFormSolicitudTransferencia,
  },
  data() {
    return {
      checkbox: false,
      tipo: TIPOS_SOLICITUD.RECURSOS,
      estado: localStorage.getItem('estadoSolicitudTransRecursos') || ESTADOS_SOLICITUD.TODOS,
      estadosSeleccionadosDetalleSolicitud: JSON.parse(
        localStorage.getItem('estadosSeleccionadosDetalleSolicitudTransRecursos'),
      ) || [ESTADOS_DETALLE_SOLICITUD.PENDIENTE],
    };
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      if (!this.checkbox) {
        this.listarRestableciendoPagina();
      }
    },
    checkbox() {
      this.listarRestableciendoPagina();
    },
    estadosSeleccionadosDetalleSolicitud(value) {
      localStorage.setItem('estadosSeleccionadosDetalleSolicitudTransRecursos', JSON.stringify(value));
      this.listarRestableciendoPagina();
    },
  },
  created() {},
  methods: {
    obtenerParametros(conSedeOrigen = false) {
      this.establecerRangoFechasConsulta();
      this.establecerRangoFechasConsultaDesembolso();

      return {
        tipo: this.tipo,
        estado: this.estado != ESTADOS_SOLICITUD.TODOS ? this.estado : null,
        fecha_inicio: this.fechaInicio ? moment(this.fechaInicio).format('YYYY-MM-DD') : null,
        fecha_fin: this.fechaFin ? moment(this.fechaFin).format('YYYY-MM-DD') : null,
        sede_origen_id: !this.checkbox && conSedeOrigen ? this.$store.state.CARGO.sede.id : null,
        estados_detalle_solicitud: this.estadosSeleccionadosDetalleSolicitud,
        fecha_inicio_desembolso:
          !this.deshabilitadoRangoFechasDesembolso && this.fechaInicioDesembolso
            ? moment(this.fechaInicioDesembolso).format('YYYY-MM-DD')
            : null,
        fecha_fin_desembolso:
          !this.deshabilitadoRangoFechasDesembolso && this.fechaFinDesembolso
            ? moment(this.fechaFinDesembolso).format('YYYY-MM-DD')
            : null,
        limite: this.limite,
        pagina: this.pagina,
        buscar: this.searchQuery,
      };
    },
    async verPdfTodos() {
      const params = this.obtenerParametros(true);

      await this.verPdfTodosMixin(params);
    },
    async verPdfTodosConsolidado() {
      const params = this.obtenerParametros(false);

      await this.verPdfTodosConsolidadoMixin(params);
    },
    async verPdfTodosConsolidadoSubtotales() {
      const params = this.obtenerParametros(false);

      await this.verPdfTodosConsolidadoSubtotalesMixin(params);
    },
    async verPdfTodosConsolidadoPorCuentaOrigen() {
      const params = this.obtenerParametros(false);

      await this.verPdfTodosConsolidadoPorCuentaOrigenMixin(params);
    },
    async listar() {
      const params = this.obtenerParametros(true);

      await this.listarMixin(params);
    },
    cambiarFiltroEstadoSolicitud() {
      localStorage.setItem('estadoSolicitudTransRecursos', this.estado);
      this.listarRestableciendoPagina();
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-btn:not(.v-btn--round).v-size--small {
  min-width: 40px;
  padding: 0 6px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}
::v-deep .v-text-field .v-input__control .v-input__slot,
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

@media (max-width: 1264px) {
  .margen-top {
    margin-top: 6px !important;
  }
}

/* v-date-picker */
::v-deep .accent {
  background-color: #005caf !important;
  border-color: #005caf !important;
}
</style>
      
